import React from 'react';
import styles from './Banco.module.scss';
import { setBetBanco } from '../../../../../store/actions/betSlip';
import { useDispatch } from 'react-redux';
import { getTranslation } from '../../../../../utils/translation';

const Banco = ({ bet }) => {
    const dispatch = useDispatch();

    const onBancoClick = () => {
        dispatch(
            setBetBanco({
                eventId: bet.eventId,
                marketId: bet.marketId,
                outcomeId: bet.outcomeId,
            })
        );
    };

    return (
        <div className={styles.banco}>
            <label>
                <input type='checkbox' value='1' hidden />
                <span
                    className={`${styles.bancoBtn} ${bet.banco ? styles.selected : ''}`}
                    onClick={onBancoClick}
                >
                    {getTranslation('bancoButton')}
                </span>
            </label>
        </div>
    );
};

export default Banco;
